import { FormHelperText, MenuItem, Select } from '@mui/material';
import theme from '../../../../../styles/themes/default';

interface OptionsSelect {
  value: string;
  id: string;
}
interface Props {
  options: OptionsSelect[];
  placeHolder: string | null;
  onChange: (element: any) => void;
  value: any;
  errorMessage: string | null;
  error: boolean;
}

const selectStyle = {
  width: '100%',
  fontSize: '14px',
  fontWeight: 400,
  flex: 1,
  color: '#1A191A',
  borderRadius: '8px',
  borderColor: '#CCCBCC',
  TextDecoderatio: 'none',
  height: '48px',
  '&:hover': {
    border: '#CCCBCC !important',
  },
  '&:focus': {
    border: '#CCCBCC !important',
  },
  root: {
    '&:hover': {
      borderColor: 'transparent !important',
    },
    '&:focus': {
      borderColor: 'transparent !important',
    },
  },
};

const InputSelect = ({
  options,
  placeHolder,
  onChange,
  value,
  errorMessage,
  error,
}: Props) => {
  return (
    <>
      <Select
        error={error}
        style={selectStyle}
        value={value || ''}
        onChange={onChange}
        placeholder="Selecione..."
        displayEmpty
        MenuProps={{
          PaperProps: {
            style: {
              borderRadius: '8px',
              border: '1px solid #CCCBCC',
              color: '#1A191A',
              maxHeight: '200px',
              overflow: 'auto',
            },
          },
        }}
      >
        <MenuItem value="" selected disabled>
          {!placeHolder ? 'Selecione...' : placeHolder}
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            style={{
              fontSize: '16px',
              color: '#807E80',
            }}
            key={option.id}
            value={option.id}
          >
            {option.value}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <FormHelperText
          style={{
            position: 'absolute',
            margin: 0,
            lineHeight: '100%',
            fontSize: '12px',
            color: theme.colors.attention,
            bottom: '-16px',
            height: 'fit-content',
            left: '16px',
          }}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};

export default InputSelect;
